import gql from 'graphql-tag';

const query = gql`
  query bloodSugarLast($withInsulinDose: Boolean = false) {
    diabetes {
      bloodSugarMeasurements {
        lastUserMeasurement(withInsulinDose: $withInsulinDose) {
          id
          value {
            value
            unit
          }
          valueLabel
          date
          mealType
          insulinDose {
            dose
            carbohydrateUnits
            insulinToCarbRatio
            insulinCorrectionFactor
          }
          __typename
        }
      }
    }
  }
`;

export default query;
